/**
 * @author        yontaek@zumper.com (Yon Taek Chung)
 * @copyright     Copyright (c) 2023, Zumper
 * @description   ListCardRating
 */

import cn from 'classnames'
import React from 'react'
import { getRatingScoreText } from '../helpers'
import css from './ListCardRating.module.scss'

export const ListCardRating = ({
  gapStyle,
  rating,
  ratingStyle,
  textStyle,
}: {
  gapStyle?: string
  rating?: number | null
  ratingStyle?: string
  textStyle?: string
}) => {
  if (!rating) {
    return <p className={cn(css.noRatingText, textStyle)}>No rating</p>
  }

  const ratingText = getRatingScoreText(rating)

  return (
    <div className={cn(css.container, gapStyle)}>
      <div className={cn(css.ratingContainer, ratingStyle)}>{rating}</div>
      <p className={cn(css.ratingText, textStyle)}>{ratingText}</p>
    </div>
  )
}
